<template>
  <div>
    <div id="company_chart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    props:{
        quality:{
            type: Number,
            default: 0,
        },
        institution:{
            type: Number,
            default: 0,
        },
        industry:{
            type: Number,
            default: 0,
        },
        valuation:{
            type: Number,
            default: 0,
        },
        trend:{
            type: Number,
            default: 0,
        },
    },
    mounted(){
        this.company_chart();
    },
    watch:{
        quality:{
            handler(val, oldVal){
                if(val){
                    this.company_chart();//传值之后再渲染
                }
            },
            deep:true //true 深度监听
        }
    },
    methods:{
        company_chart(){
            var source = {
                data: [this.quality, this.institution, this.industry, this.valuation, this.trend],
                indicator: [
                    { name: '公司质地', max: 100},
                    { name: '机构观点', max: 100},
                    { name: '行业水平', max: 100},
                    { name: '估值水平', max: 100},
                    { name: '短期走势', max: 100},
                ]
            }
            function fontSize(res){
                let docEl = document.documentElement,
                    clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
                if (!clientWidth) return;
                let fontSize = (clientWidth / 750);
                return res*fontSize;

            }
            // 基于准备好的dom，初始化echarts实例
             var myChart = echarts.init(document.getElementById('company_chart'));
            // 指定图表的配置项和数据
            var option = {
                tooltip:{
                    textStyle: {
                        color: '#333333',
                        fontSize:fontSize(20),
                    },
                    backgroundColor:'#FFFBFB',	//tooltip背景色
                    borderColor:'#FFA391',		//tooltip边框颜色
                    borderWidth:3,
                    formatter: function (param,e) {	//自定义tooltip内容
                        var text = '';
                        //console.log(param,e)
                        text += '<div style="line-height: 0.3rem">'+'公司质地'+'：'+param.value[0]+'</div>';
                        text += '<div style="line-height: 0.3rem">'+'机构观点'+'：'+param.value[1]+'</div>';
                        text += '<div style="line-height: 0.3rem">'+'行业水平'+'：'+param.value[2]+'</div>';
                        text += '<div style="line-height: 0.3rem">'+'估值水平'+'：'+param.value[3]+'</div>';
                        text += '<div style="line-height: 0.3rem">'+'短期走势'+'：'+param.value[4]+'</div>';
                        return text;
                    }
                },
                title: {
                    text: ''
                },
                legend: {},
                radar: {
                    style:{
                        width : '100%',
                    },
                    radius: ['5%','60%'],
                    splitNumber: 4, // 雷达图圈数设置
                    axisLine: { // (圆内的几条直线)坐标轴轴线相关设置
                        lineStyle: {
                            color: '#FF8A8A', // 坐标轴线线的颜色。
                            width: 1, // 坐标轴线线宽。
                            type: 'solid', // 坐标轴线线的类型。
                        }
                    },
                    splitLine: { // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
                        lineStyle: {
                            color: ['#FFBABA','#FFD5D5', '#FFEBEB','#FFFFFF','#FF8A8A'], // 分隔线颜色
                            width: 1, // 分隔线线宽
                        }
                    },
                    splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
                        show: true,
                        areaStyle: { // 分隔区域的样式设置。
                            color: ['#FFBABA','#FFD5D5', '#FFEBEB','#FFFFFF'],
                            // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                        }
                    },
                    indicator: source.indicator,
                    name: {
                        textStyle: {
                            color: '#636363',
                            fontSize: fontSize(24),
                        }
                    },
                    //triggerEvent: true,
                },
                series: [{
                    name: '',
                    type: 'radar',
                    data: [
                        {
                            value: source.data,
                            name: '',
                            symbol: 'circle',
                            itemStyle: {
                                normal: {
                                    color: "#ffff",
                                    borderColor: '#FF8A8A',
                                    borderWidth: 0.5,
                                }
                            },
                            areaStyle: {
                                color: 'rgba(255,84,84,.5)',
                            }
                        }
                    ]
                }]

            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);

        },
    }
}
</script>

<style>

</style>